export default __webpack_public_path__ + "a04ad7b130231a41c17eeb14dfba8901.png";